import { Banner } from "@shopify/polaris";

const BundleAsProductError = ({ bundleConfig }: { bundleConfig?: any }) => {
    return bundleConfig &&
        bundleConfig?.hasOwnProperty("bundle_as_product") &&
        bundleConfig?.bundle_as_product == null ? (
        <div
            style={{
                marginBottom: 14,
            }}
        >
            <Banner title={"This bundle may not work properly"} tone={"warning"}>
                Looks like this product was deleted from your Shopify store. Please create a new bundle to avoid any
                errors
            </Banner>
        </div>
    ) : (
        <></>
    );
};

export default BundleAsProductError;
